import { get, post, baseURL, put, remove } from './config'

// 文件上传
export const uploadURL = baseURL + '/wapi/v1/upload'

// 下载的文件地址
/* export const downloadModel = {
  'production': '',
  'development': 'http://192.168.1.186:9903/预算科目模版.xlsx',
  'lan': 'http://192.168.1.124:8060/预算科目模版.xlsx'
}[process.env.NODE_ENV] */

/**
 * 登录验证
 * @param {*} data
 */
export const login = (data) => post(`/wapi/v1/auth/login`, data)

/*
 * ============== start  公用接口 ==================
*/

/**
 * 文件删除
 * @param {*} data
 */
export const removeFile = (data) => remove(`/wapi/v1/media`, data)

/*
 * ============== end  公用接口 ==================
*/

/*
 * ============== start  小程序管理 ==================
*/

/**
 * 获取已有的小程序列表
 * @param {*} data
 */
export const getOwnedAppletList = (data) => get(`/wapi/v1/mps/reviewed`, data)

/**
 * 获取小程序详情
 * @param {*} id
 */
export const getAppletDetails = (id) => get(`/wapi/v1/mp/${id}`)

/**
 * 更改小程序上下架状态
 * @param {*} data
 */
export const updateAppletStatus = (id, data) => put(`/wapi/v1/mp/${id}/switch`, data)

/**
 * 添加小程序信息
 * @param {*} data
 */
export const addApplet = (data) => post(`/wapi/v1/mp`, data)

/**
 * 更新小程序信息
 */
export const updateApplet = (id, data) => put(`/wapi/v1/mp/${id}`, data)

/**
 * 获取检索的小程序列表(审核的)
 * @param {*} data
 */
export const getCheckAppletList = (data) => get(`/wapi/v1/mps/audited`, data)

/**
 * 更改小程序审核状态
 * @param {*} id
 * @param {*} data
 */
export const updateCheckStatus = (id, data) => put(`/wapi/v1/mp/${id}/review`, data)

/**
 * 获取小程序未审核数量
 */
export const getNotCheckCount = () => get(`/wapi/v1/mp/un_audited/count`)

/*
 * ============== end  小程序管理 ==================
*/

/*
 * ============== start  专题管理 ==================
*/

/**
 * 获取专题列表
 * @param {*} data
 */
export const getTopicsList = (data) => get(`/wapi/v1/topics`, data)

/**
 * 添加专题信息
 * @param {*} data
 */
export const addTopics = (data) => post(`/wapi/v1/topic`, data)

/**
 * 获取专题详情
 * @param {*} id
 */
export const getTopicsDetails = (id) => get(`/wapi/v1/topic/${id}`)

/**
 * 更新专题信息
 * @param {*} id
 * @param {*} data
 */
export const updateTopicsDetails = (id, data) => put(`/wapi/v1/topic/${id}`, data)

/*
 * ============== end  专题管理 ==================
*/

/**
 * ============== start 轮播图管理 ==================
*/

/**
 * 获取轮播图列表
 */
export const getSwiperList = () => get(`/wapi/v1/banners`)

/**
 * 更新轮播图图片
 */
export const updateSwiperList = (data) => put(`/wapi/v1/banners`, data)

/*
 * ============== end  专题管理 ==================
*/



// WEBPACK FOOTER //
// ./src/api/index.js